var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.747,
    height: 20.747,
    viewBox: "0 0 20.747 20.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M10,20.374A10.374,10.374,0,1,1,20.374,30.747,10.373,10.373,0,0,1,10,20.374Zm13.4,6.164a1.1,1.1,0,0,0,0-1.562l-4.6-4.6,4.6-4.6a1.1,1.1,0,1,0-1.562-1.562l-5.383,5.383a1.1,1.1,0,0,0,0,1.562l5.383,5.383A1.1,1.1,0,0,0,23.4,26.537Z",
    transform: "translate(-10 30.747) rotate(-90)",
    fill: "#f68e3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnIcon);
export default __webpack_public_path__ + "static/media/kn-icon.047da2a624400fd0adf8b186ca868149.svg";
export { ForwardRef as ReactComponent };